import { Box, Button } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { SearchOffOutlined } from '@mui/icons-material';
import { tokens } from '@synergy/theme-palo';
import { useNavigate } from 'react-router-dom';

const c = tokens.color;

export interface PaloNotFoundProps {
    /** What was looked for, e.g. "Diesen Artikel gibt es nicht." */
    title: ReactNode;
    /** Where the way back leads. */
    backTo: string;
    backLabel: ReactNode;
}

/**
 * Shown where a record was expected and none exists.
 *
 * An address with an unknown number used to open the empty mask of a new
 * record, which reads as a document that lost its content — and what is typed
 * into it is saved as something new.
 */
export const PaloNotFound = ({ title, backTo, backLabel }: PaloNotFoundProps): ReactElement => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '14px',
                padding: '48px 16px',
                backgroundColor: c.canvas,
                color: c.ink2,
                textAlign: 'center',
            }}
        >
            <SearchOffOutlined sx={{ fontSize: 40, color: c.ink3 }} />
            <Box sx={{ fontSize: '15px', fontWeight: 640, color: c.ink }}>{title}</Box>
            <Button variant="outlined" color="inherit" size="small" onClick={() => navigate(backTo)}>
                {backLabel}
            </Button>
        </Box>
    );
};
